import { getBonusQuestion, playBonusQuestion } from "@/api/bonusQuestion/api"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { PlayBonusQuestionRequest } from "swagger/models"

export const useGetBonusQuestion = (bonusQuestionId: string) => {
  const { data: { data: bonusQuestion } = {}, ...rest } = useQuery(
    ["bonusQuestion", bonusQuestionId],
    () => getBonusQuestion(bonusQuestionId),
    {
      retry: 1,
      enabled: true,
    },
  )

  return {
    bonusQuestion,
    ...rest,
  }
}

export const useUpdatePlayerBonusQuestion = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ body, bonusQuestionId }: { body: PlayBonusQuestionRequest; bonusQuestionId: string }) =>
      playBonusQuestion(body, bonusQuestionId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["playerData"])
        queryClient.invalidateQueries(["comicsDetail"])
      },
    },
  )
}
